import { Paper, Stack, Title, Text, Divider, Box, ScrollArea } from '@mantine/core';
import type { OverviewActivityEvent } from '../../../../types';
import { ActivityItem } from './ActivityItem';

interface RecentActivityFeedProps {
  activities: OverviewActivityEvent[];
}

const ACTIVITY_LIST_MAX_HEIGHT = 350;

export function RecentActivityFeed({ activities }: RecentActivityFeedProps) {
  return (
    <Paper
      p="md"
      radius="md"
      bg="white"
      styles={{ root: { boxShadow: 'none' } }}
      style={{ border: '1px solid var(--mantine-color-gray-2)' }}
    >
      <Stack gap="md">
        <Box>
          <Title order={5}>Recent Activity</Title>
          <Text size="sm" c="dimmed">
            Latest updates
          </Text>
        </Box>

        <Divider />

        {activities.length === 0 ? (
          <Text size="sm" c="dimmed" ta="center" py="lg">
            No recent activity
          </Text>
        ) : (
          <ScrollArea.Autosize
            mah={ACTIVITY_LIST_MAX_HEIGHT}
            type="auto"
            scrollbars="y"
            offsetScrollbars
          >
            <Stack gap="xs">
              {activities.map(activity => (
                <ActivityItem key={activity.id} activity={activity} />
              ))}
            </Stack>
          </ScrollArea.Autosize>
        )}
      </Stack>
    </Paper>
  );
}

export default RecentActivityFeed;
